export const BOOKING_TYPE_FILTER_COLOR_MAPPING : {[key:string]: {[key:string]:string}} =  {
  ACTIVE: {
    button: 'bg-blue-light',
    count: 'bg-opacity-10 bg-white'
  },
  INACTIVE: {
    button: 'bg-white text-grey-dark font-medium text-sm',
    count: 'bg-grey-subtle'
  }
}

export const BOOKING_TYPE = ({ all, regular, event }: { all: number, regular: number, event: number }) : BookingTypeFilter[] => [
  {
    key: 'ALL',
    label: 'All Types',
    count: all
  },
  {
    key: 'REGULAR',
    label: 'Regular',
    count: regular
  },
  {
    key: 'EVENT',
    label: 'Event',
    count: event
  }
]

export const BOOKING_STATUS = {
  CREATED: {
    textColor: 'text-purple-secondary',
    bgColor: 'bg-purple-secondary bg-opacity-10'
  },
  CONFIRMED: {
    textColor: 'text-blue-light',
    bgColor: 'bg-blue-light bg-opacity-10'
  },
  CANCELED: {
    textColor: 'text-grey-dark',
    bgColor: 'bg-grey-dark bg-opacity-10'
  },
  EXPIRED: {
    textColor: 'text-grey-dark',
    bgColor: 'bg-grey-dark bg-opacity-10'
  },
  UNPAID: {
    textColor: 'text-yellow-secondary',
    bgColor: 'bg-yellow-secondary bg-opacity-10'
  },
  REFUND: {
    textColor: 'text-red-primary',
    bgColor: 'bg-red-primary bg-opacity-10'
  },
  PARTIAL_REFUND: {
    textColor: 'text-red-primary',
    bgColor: 'bg-red-primary bg-opacity-10'
  },
  PAID: {
    textColor: 'text-green-secondary',
    bgColor: 'bg-green-secondary bg-opacity-10'
  },
  RESCHEDULED: {
    textColor: 'text-green-secondary',
    bgColor: 'bg-green-secondary bg-opacity-10'
  }
}

export const statusOptions = [
  'UNPAID',
  'PAID',
  'REFUND',
  'PARTIAL_REFUND',
  'EXPIRED',
  'CANCELED',
  // 'RESCHEDULED'
]